import { gql } from 'graphql-request'
import { createQuery } from '@fivehealth/botero'

const GRAPHQL_DOCUMENT = gql`
  mutation einsteinBroadcastUpdate($input: UpdateEinsteinBroadcastInput!) {
    einsteinBroadcastUpdate(input: $input) {
      einsteinBroadcast {
        name
        uid
        messages
        status
        scheduledFor
      }
    }
  }
`

export default createQuery({
  gqlDocument: GRAPHQL_DOCUMENT,
  queryType: 'mutation',
  baseQueryKey: 'einsteinBroadcasts',
  keepPreviousData: true,
  allowErrorResponse: true,
})
